import {
  FOOD,
  POPULAR_FOOD,
  FOOD_DETAILS
} from '../../actions/actionTypes'
import { DELETE_BOOKMARK, ADD_BOOKMARK, CLEAR_BOOKMARK } from '../../actions/actionTypes'

const initailState = []

const bookmark = (state = initailState, action) => {
  switch (action.type) {
  case ADD_BOOKMARK: {
    const { contentType, contentId } = action.payload
    return [
      ...state,
      {
        id: Date.now(),
        contentType,
        contentId
      }
    ]
  }
  case DELETE_BOOKMARK: {
    return state.filter(value => value.id !== action.id)
  }
  case CLEAR_BOOKMARK: {
    return initailState
  }
  default:
    return state
  }
}
export default bookmark


// WEBPACK FOOTER //
// ./src/containers/Bookmark/reducer.js